<div
  class="c-tournamentRankingList"
  [ngClass]="{
    'c-tournamentRankingList--mainUser': isSelf,
    'ranking-up': player.positionChange === 'up',
    'ranking-down': player.positionChange === 'down'
  }">
  <div class="e-tournamentRankingList__position">
    <div
      theming
      themingGroup="tournament"
      [themingAsset]="'rank-' + (rankingPosition <= PODIUM ? rankingPosition : 'other')"
      [themingOverride]="event?.assets">
      @if (rankingPosition > PODIUM) {
        <span>{{ rankingPosition }}</span>
      }
    </div>
  </div>

  <div class="e-tournamentRankingList__container">
    <div class="e-tournamentRankingList__avatar">
      <slotcom-avatar [userId]="player.userId"></slotcom-avatar>
    </div>

    <span class="e-tournamentRankingList__username"> {{ player.nickName }} </span>

    <div class="e-tournamentRankingList__rewards">
      @for (prize of rankingPrize | keyvalue; track prize) {
        @if (prize.value) {
          <slotcom-reward-box
            boxThemingGroup="tournament"
            iconThemingGroup="none"
            boxAsset="reward-inactive"
            [iconAsset]="prize.key | lowercase"
            [themingOverride]="event?.assets"
            [numberValue]="prize.value">
          </slotcom-reward-box>
        }
      }
    </div>
  </div>

  <div class="e-tournamentRankingList__points">
    <slotcom-display [classes]="['c-display--tournament']">
      <div
        displayIcon
        displayIconPos="left"
        theming
        themingGroup="tournament"
        themingAsset="icon-points"
        [themingOverride]="event?.assets"
        class="c-display--theming"></div>
      {{ player.rankingScore | notRoundingBeautifyNumber: ('common.culture' | translate) }}
    </slotcom-display>
  </div>
</div>
